export default "__VITE_ASSET__BErdjKg5__"